import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

export const Container = styled(Box)(() => ({
  padding: '24px',
  maxWidth: '1200px',
  margin: '0 auto',
}));

export const GameTitle = styled(Typography)(({ theme }) => ({
  fontSize: '20px',
  fontWeight: 700,
  marginBottom: '4px',
  color: theme.custom.text,
}));

export const GameDate = styled(Typography)(({ theme }) => ({
  fontSize: '13px',
  fontWeight: 400,
  color: theme.custom.text,
}));

export const HeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '16px 24px',
  backgroundColor: theme.custom.background1,
  borderBottom: `1px solid ${theme.custom.stroke}`,
}));

export const HeaderLink = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 400,
  color: theme.custom.textLight,
  textDecoration: 'none',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  '&:hover': {
    color: theme.custom.text,
  },
}));

export const StyledChevronRight = styled(ChevronRightIcon)(({ theme }) => ({
  fontSize: '16px',
  color: theme.custom.textLight,
}));
